import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';

import {
  BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES,
  setRemoveSuperBatchesModalStage,
} from 'features/classCreation';
import SectionHeading from 'components/SectionHeading';
import SelectedSbatGroupsForBulkUpdate from '../SelectedSbatGroupsForBulkUpdate';
import styles from './BulkRemoveSuperBatchesModalInfoStage.module.scss';

export default function BulkRemoveSuperBatchesModalInfoStage() {
  const dispatch = useDispatch();

  const handleOnClick = useCallback(() => {
    dispatch(
      setRemoveSuperBatchesModalStage(
        BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.select
      )
    );
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <SectionHeading
        title={
          <>
            <Icon
              name="minus-circle"
              className="primary m-r-xxs"
            />
            Remove Batch/es
          </>
        }
        titleClassName={styles.heading}
        className={styles.sectionHeading}
      />
      <SelectedSbatGroupsForBulkUpdate />
      <div className={styles.text}>
        Batches will be removed from the above selected classes.
      </div>
      <Tappable
        className="btn btn-primary m-t-xs"
        onClick={handleOnClick}
      >
        Select Batches to be removed
      </Tappable>
    </div>
  );
}
